import { render, staticRenderFns } from "./O3DEditor.vue?vue&type=template&id=fdd48ffa&"
import script from "./O3DEditor.vue?vue&type=script&lang=js&"
export * from "./O3DEditor.vue?vue&type=script&lang=js&"
import style0 from "./O3DEditor.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports